import AiAssistantBanner from 'views/blog/subcomponents/AiAssistantBanner';
import AssistantCover from './Cover';

export { AssistantCover, AiAssistantBanner };
